require('es6-promise').polyfill()
import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

// load global methods from external files
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

const user = {}
const bank_aggregator_list = [];
const ipv_response = {
  digio_doc_id: '',
  message: 'loading',
  txn_id: '',
};

const message = {
  info: '',
  msg: '',
  errors: []
}


const loaders = {
  a: false,
  b: false,
  c: false
}

export default new Vuex.Store({
  state: {
    user,
    message,
    loaders,
    bank_aggregator_list,
    ipv_response
  },
  actions,
  getters,
  mutations,
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js